import { render, staticRenderFns } from "./NotificationsListItem.vue?vue&type=template&id=67c134d6&scoped=true&"
import script from "./NotificationsListItem.vue?vue&type=script&lang=js&"
export * from "./NotificationsListItem.vue?vue&type=script&lang=js&"
import style0 from "./NotificationsListItem.vue?vue&type=style&index=0&id=67c134d6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67c134d6",
  null
  
)

export default component.exports